var map = Array.prototype.map;
var reduce = Array.prototype.reduce;
var forEach = Array.prototype.forEach;

function fixWidth(year) {
	var yearRect;
	var firstRect;
	var colsCount = reduce.call(
		year.querySelectorAll('p'),
		function(res, p) {
			var rect = p.getBoundingClientRect();
			if(!firstRect) {
				firstRect = rect;
			}
			if(res.indexOf(rect.left) === -1) {
				res.push(rect.left);
			}
			return res;
		},
		[]
	).length;
	year.style.width = colsCount * firstRect.width + 'px';
	return year.getBoundingClientRect().width;
}

function sum(r, n) {
	return r + n;
}

module.exports = function() {
	var story = document.querySelector('.history');

	if(!story) {
		return;
	}

	var shaft = story.querySelector('.history__shaft');
	var line = story.querySelector('.history__line');
	var pin = story.querySelector('.history__pin');
	var trace = story.querySelector('.history__trace');
	var points = story.querySelectorAll('.history__point');
	var contW = 0;
	var scrollPrc = 0;
	var yearWidths = map.call(shaft.querySelectorAll('.history__year'), fixWidth);
	var shaftW = yearWidths.reduce(sum, 0);

	var skip = 0;
	var lastW = yearWidths[yearWidths.length - 1];
	var pointsPrc = yearWidths.reduce(function(res, w, i) {
		if(res.length === 0) {
			res.push(0);
		} else {
			res.push(res[res.length -1] + w / (shaftW - lastW) * 100);
		}
		points[i].style.left = res[res.length - 1] + '%';
		return res;
	}, []);

	function thresholdPrc(prc) {
		return Math.max(0, Math.min(prc, 100));
	}

	function scrollTo(prc) {
		prc = thresholdPrc(prc);
		var pos = 0 - (shaftW - contW) / contW * prc;
		shaft.style.left = pos + '%';
		pin.style.left = trace.style.left = prc + '%';
	}

	function onResize() {
		var rect = shaft.getBoundingClientRect();
		contW = rect.width;
		scrollTo(scrollPrc);
	}

	function onPointClick(i) {
		scrollPrc = pointsPrc[i];
		scrollTo(scrollPrc);
	}

	function onScaleClick(evt) {
		var rect = evt.target.getBoundingClientRect();
		scrollPrc = (evt.pageX - rect.left) / contW * 100;
		scrollTo(scrollPrc);
	}

	var draggin = false;
	var prevX = 0;
	function onMouseDown(evt) {
		document.body.classList.add('st-draggin');
		draggin = true;
		prevX = evt.pageX;
	}

	function onMouseUp() {
		document.body.classList.remove('st-draggin');
		draggin = false;
	}

	function onMouseMove(evt) {
		if(!draggin) {
			return;
		}

		var delta = evt.pageX - prevX;
		var deltaPrc = delta / contW * 100;

		scrollPrc += deltaPrc;
		scrollTo(scrollPrc);

		prevX = evt.pageX;
	}

	forEach.call(
		points,
		function(point, i) {
			point.addEventListener('click', onPointClick.bind(null, i));
		}
	);

	window.addEventListener('resize', onResize);
	line.addEventListener('click', onScaleClick);
	pin.addEventListener('mousedown', onMouseDown);
	document.addEventListener('mouseup', onMouseUp);
	document.addEventListener('mousemove', onMouseMove);
	onResize();

};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/history.js
 **/